import { IUser, IUserGroup, IUser_Group } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FormItemStyled, FormStyled } from 'fwork.react.apptemplate'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { FaTrash } from 'react-icons/fa'
import axios from "../../apiClient/axios"
import { UserGroupsApiClient } from '../../apiClient/userGroups'
import { DEFAULTGAP } from '../../globals'
import { DropDownSearchComponent } from '../common/dropDownSearch'
import { HeaderComponent } from '../common/header'

export interface UserGroupsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  data?: IUser_Group[],
  onSelectItem?: ((item: IUser_Group, group: IUserGroup) => void) | undefined,
  onDeleteItem?: (item: IUser_Group) => void,
  onAddItem?: () => void,
}

export const UserGroupsComponent = (props: UserGroupsComponentProps) => {
  const { data, onSelectItem, onDeleteItem, onAddItem, ...rest } = props
  const { enqueueSnackbar } = useSnackbar()

  const [gettingUsersGroups, setGettingUsersGroups] = useState<boolean>()
  const getUsersGroups = async (filter: string) => {
    if (gettingUsersGroups) return
    setGettingUsersGroups(true)

    try {
      const response = await new UserGroupsApiClient(axios).get({
        where: {
          name: { $regex: filter, $options: 'i' }
        },
        sort: { name: 1 }
      })
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingUsersGroups(false)
    }
  }

  return <div {...rest}>
    <FormStyled style={{ width: '100%' }}>
      <FormItemStyled gap={DEFAULTGAP} style={{ width: '100%' }}>
        <HeaderComponent
          title=''
          onAddClick={props.onAddItem}
        />
      </FormItemStyled>

      {props.data?.map((u_g, idx) => <FormItemStyled key={idx} gap={DEFAULTGAP}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          rowGap: DEFAULTGAP,
          columnGap: DEFAULTGAP,
        }}>
        <DropDownSearchComponent
          id={`DropDownSearchComponent${idx}`}
          initInputValue={u_g?.usergroup?.name || ''}
          progress={gettingUsersGroups}
          style={{ width: '100%' }}
          label="Grupo"
          modelLabelName="name"
          dataBuilder={async (typedText: string | undefined) => {
            if (typedText)
              return await getUsersGroups(typedText)
          }}
          onSelectItem={(userGroup: IUserGroup) => {
            if (props.onSelectItem)
              props.onSelectItem(u_g, userGroup)
          }}
        />
        <FaTrash style={{ cursor: 'pointer', }} color='grey' size={20} onClick={() => {
          if (props.onDeleteItem)
            props.onDeleteItem(u_g)
        }} />
      </FormItemStyled>)}
    </FormStyled>
  </div>
}